<template>
	<div class="products">
		<h2 class="product-title" v-if="item.titleFlag==1">{{item.detailTitle}}</h2>
		<ul class="product-nav">
			<li @click="changeSystem(item.id, item2.id,index)" :class="[systemIndex==index?'active':'']"
				v-for="(item2,index) in item.list">{{item2.categoryName}}</li>
		</ul>
		<div class="product-cnt">
			<div class="main-cnt" v-for="item3 in systemList">
				<div class="main-cnt-l">
					<img :src="item3.picUrl" />
				</div>
				<div class="main-cnt-r">
					<div class="p-title">{{item3.title}}</div>
					<div class="p-text lineclamp3">{{item3.content}}</div>
					<a class="link" :href="item3.webUrl" target="_blank">
						<span class="text">了解更多</span>
						<span class="el-icon-right"></span>
					</a>
				</div>
			</div>
			<div class="line"></div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'SystemTab',
		props: {
			item: {
				type: Object,
				value: {}
			}
		},
		data(){
			return{
				systemIndex: 0,
				systemList: []
			}
		},
		created(){
			if(this.item.list.length>0){
				this.getSystemList(this.item.id,this.item.list[0].id)
			}
		},
		methods: {
			//切换操作系统分类
			changeSystem(detailId, systemId, index) {
				this.systemIndex = index
				this.getSystemList(detailId,systemId)
			},
			//获取系统分类数据
			async getSystemList(detailId, systemId) {
				let param = {
					detailId: detailId,
					categoryIdOne: systemId
				}
				ajaxParam(param)
				const res = await post('v1/product/systemList', qs.stringify(param))
				if (res.data.code == 200) {
					this.systemList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			}
			
		}
	}
</script>

<style scoped lang="less">
	.products {
		padding-top: 50px;
		//padding-top: 110px;
		.product-title {
			font-size: 34px;
			text-align: center;
		}
	
		.product-nav {
			display: flex;
			width: 1180px;
			background: #fff;
			border-radius: 30px;
			margin: 40px auto 0;
			line-height: 1.95;
			font-size: 16px;
			justify-content: space-around;
	
			li {
				width: 25%;
				padding: 15px 0;
				text-align: center;
				cursor: pointer;
			}
	
			li.active {
				background: #DE0515;
				border-radius: 30px;
				color: #fff;
			}
	
			li.active:hover {
				color: #fff;
			}
	
			li:hover {
				color: #DE0515;
			}
		}
	
		.product-cnt {
			width: 1180px;
			margin: 0 auto;
			padding-top: 40px;
	
			.main-cnt {
				display: flex;
				justify-content: space-between;
				background: #fff;
				border-radius: 10px;
				// margin-bottom: 50px;
	
				.main-cnt-l {
					width: 40%;
					padding: 40px 0 40px 40px;
	
					img {
						width: 100%;
					}
				}
	
				.main-cnt-r {
					flex: 1;
					padding: 52px 60px 60px 60px;
					line-height: 1.95;
	
					.p-title {
						padding-bottom: 10px;
						font-size: 28px;
					}
	
					.p-text {
						margin-bottom: 20px;
						color: #666;
					}
				}
			}
	
			.type-cnt {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
	
				li {
					width: 31%;
					margin-bottom: 40px;
	
					.type-list {
						padding: 42px 50px 45px 50px;
						background: #fff;
	
						.type-h3 {
							padding-bottom: 20px;
							font-size: 28px;
							line-height: 1.57;
						}
	
					}
				}
			}
		}
	}
	.link {
		display: flex;
		align-items: center;
		color: #DE0515;
	
		.text {
			line-height: 1.625;
		}
	
		.el-icon-right {
			font-size: 22px;
		}
	}
</style>
